import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageHeader, Panel } from "@/components/common";
import { api, fmtDateTime } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { BulkDeleteBar, useSelection } from "@/components/BulkDelete";

const LABELS = {
  setup: "Configurazione iniziale", login: "Accesso", password_change: "Cambio password", password_reset_request: "Richiesta recupero password", password_reset: "Password reimpostata", settings_update: "Personalizzazione aggiornata",
  user_create: "Utente creato", user_update: "Utente modificato", leave_create: "Richiesta ferie", permission_create: "Richiesta permesso",
  leaves_approved: "Ferie approvate", leaves_rejected: "Ferie rifiutate", leaves_cancel: "Ferie annullate",
  permissions_approved: "Permesso approvato", permissions_rejected: "Permesso rifiutato", permissions_cancel: "Permesso annullato",
  sick_create: "Malattia comunicata", sick_ack: "Presa visione malattia", announcement_create: "Comunicazione pubblicata",
  announcement_update: "Comunicazione modificata", announcement_delete: "Comunicazione eliminata",
  medical_upload: "Allegato medico caricato", medical_file_access: "Accesso ad allegato medico",
  invite_sent: "Invito inviato", invite_accepted: "Account attivato", leaves_edit: "Ferie modificate", leaves_revoke: "Ferie revocate",
  permissions_edit: "Permesso modificato", permissions_revoke: "Permesso revocato", logo_upload: "Logo caricato", balance_adjustment: "Rettifica saldo", self_register: "Registrazione autonoma", registration_approved: "Registrazione approvata",
  registration_rejected: "Registrazione rifiutata", registration_links_sent: "Link di registrazione inviati",
  leaves_edit_proposed: "Modifica ferie proposta", permissions_edit_proposed: "Modifica permesso proposta",
  leaves_proposal_accept: "Modifica ferie accettata", leaves_proposal_reject: "Modifica ferie rifiutata",
  permissions_proposal_accept: "Modifica permesso accettata", permissions_proposal_reject: "Modifica permesso rifiutata",
  leaves_own_edit: "Ferie modificate dal dipendente", permissions_own_edit: "Permesso modificato dal dipendente",
  closure_create: "Chiusura creata", closure_delete: "Chiusura eliminata", blackout_create: "Periodo bloccato creato",
  blackout_delete: "Periodo bloccato eliminato", meeting_create: "Richiesta incontro", meeting_accept: "Incontro accettato",
  meeting_decline: "Incontro rifiutato", meeting_cancel: "Incontro annullato",
  activity_delete: "Registro attività svuotato", email_change: "Email modificata", account_self_delete: "Account eliminato dall'utente", user_delete: "Utente eliminato", location_create: "Sede creata", location_delete: "Sede eliminata", poll_create: "Sondaggio creato", poll_close: "Sondaggio chiuso", poll_delete: "Sondaggio eliminato",
};

export default function Registro() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/activity").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const shown = items.filter((i) => `${i.actor_name} ${LABELS[i.action] || i.action} ${i.detail}`.toLowerCase().includes(q.toLowerCase()));
  const sel = useSelection(shown);
  return (
    <div data-testid="activity-page">
      <PageHeader title="Registro attività" subtitle="Traccia delle operazioni effettuate nell'app." />
      <div className="relative mb-4 max-w-sm">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input className="pl-9" placeholder="Filtra" value={q} onChange={(e) => setQ(e.target.value)} data-testid="activity-search-input" />
      </div>
      <BulkDeleteBar endpoint="/admin/activity/delete" selection={sel} total={shown.length} onDone={load} prefix="activity" noun="attività" />
      <Panel className="overflow-x-auto fade-up">
        <Table data-testid="activity-table">
          <TableHeader><TableRow><TableHead className="w-10" /><TableHead>Data e ora</TableHead><TableHead>Utente</TableHead><TableHead>Azione</TableHead><TableHead>Dettaglio</TableHead></TableRow></TableHeader>
          <TableBody>
            {shown.map((i) => (
              <TableRow key={i.id}>
                <TableCell><Checkbox checked={sel.has(i.id)} onCheckedChange={() => sel.toggle(i.id)} aria-label="Seleziona" data-testid={`activity-select-${i.id}`} /></TableCell>
                <TableCell className="whitespace-nowrap font-mono text-xs">{fmtDateTime(i.created_at)}</TableCell>
                <TableCell className="font-medium">{i.actor_name}</TableCell>
                <TableCell>{LABELS[i.action] || i.action}</TableCell>
                <TableCell className="max-w-xs truncate text-sm text-muted-foreground">{i.detail || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Panel>
    </div>
  );
}
